// extracted by mini-css-extract-plugin
export default {"addToCartControl":"OZ-z","giftCard":"PZ-z","btnContainer":"QZ-z","cartButton":"RZ-z","disabled":"SZ-z"};